<template>
	<div class="tusd-wrap wrap-bg alipay">
		<div class="page-title">
			<i class="back-btn" @click="goBack"></i>
			添加随机收款方式
		</div>
		<div class="separator"></div>
		<div class="account-wrap">

			<div class="wrap-item">
				<span class="item-label">
					支付宝账号：
				</span>
				<input type="text" v-model="account.BankAccount" placeholder="请输入支付宝账号" />
			</div>
			<div class="wrap-item">
				<span class="item-label">
					支付宝UID：
				</span>
				<input type="text" v-model="account.AlipayUid" placeholder="请输入支付宝UID" />
			</div>
			<div class="wrap-item">
				<span class="item-label">
					收款方全称：
				</span>
				<input type="text" v-model="account.BankUser" placeholder="请输入收款方全称" />
			</div>
			<div class="wrap-item">
				<span class="item-label">单日限单量：</span>
				<span class="unit">个</span>
				<input type="text" v-model="account.dayLimitOrderCount" placeholder="请输入单日限单数量" />
			</div>
			<div class="wrap-item">
				<span class="item-label">单日总限额：</span>
				<span class="unit">元</span>
				<input type="text" v-model="account.dayLimit" placeholder="请输入单日总限额" />
			</div>
			<div class="wrap-item">
				<span class="item-label">单笔最低：</span>
				<span class="unit">元</span>
				<input type="text" v-model="account.perLimitMin" placeholder="请输入单笔最低限额" />
			</div>
			<div class="wrap-item">
				<span class="item-label">单笔最高：</span>
				<span class="unit">元</span>
				<input type="text" v-model="account.perLimit" placeholder="请输入单笔最高限额" />
			</div>
			<div class="wrap-item">
				<span class="item-label">匹配间隔：</span>
				<span class="unit">分</span>
				<input type="text" v-model="account.sellTimeSpanLimit" placeholder="请输入距离上次间隔时间" />
			</div>
			<div class="wrap-item">
				<span class="item-label">分组管理：</span>
				<cube-select v-model="account.groupId" :options="bankGroupOptions"
					@change="selectBankGroup"></cube-select>
			</div>
			<div class="wrap-item">
				<span class="item-label">收款方编号：</span>
				<input type="text" v-model="account.bankRemark" placeholder="请输入收款方编号" />
			</div>
			<div class="wrap-item">
				<span class="item-label">订单客户：</span>
				<div class="radio-wrap">
					<cube-radio-group @input="changePaymentCustomerLimit"
						v-model="optionCheckedValue.paymentCustomerLimitValue" :options="paymentCustomerLimitOptions"
						:horizontal="true" />
				</div>
			</div>
			<div class="wrap-item">
				<span class="item-label">同时进账：</span>
				<div class="radio-wrap">
					<cube-radio-group @input="changeIsNeedLockedOrder"
						v-model="optionCheckedValue.isNeedLockedOrderValue" :options="isNeedLockedOrderOptions"
						:horizontal="true" />
				</div>
			</div>
			<div class="wrap-item">
				<span class="item-label">展示账号：</span>
				<div class="radio-wrap">
					<cube-radio-group @input="changeShowBankAccount" v-model="optionCheckedValue.showBankAccountStatus"
						:options="statusOptions" :horizontal="true" />
				</div>
			</div>
			<div class="wrap-item">
				<span class="item-label">展示二维码：</span>
				<div class="radio-wrap">
					<cube-radio-group @input="changeShowQrCode" v-model="optionCheckedValue.showQrCodeStatus"
						:options="statusOptions" :horizontal="true" />
				</div>
			</div>
			<div class="wrap-item item_top">
				<span class="item-label">扫码支付码：</span>
				<cube-upload class="header-wrap" ref="uploadFile" :max="1" :auto="false" @files-added="filesAdded">
					<cube-upload-btn :multiple="false">
						<div class="upload-btn"
							:style="{ 'background-image': 'url(' + (headerImg ? headerImg : '../assets/images/header.png') + ')' }">
							<i v-if="!headerImg"></i>
						</div>
					</cube-upload-btn>
				</cube-upload>
			</div>
			<div class="wrap-item item_top">
				<span class="item-label">转账支付码：</span>
				<cube-upload class="header-wrap" ref="uploadFile" :max="1" :auto="false"
					@files-added="transferFilesAdded">
					<cube-upload-btn :multiple="false">
						<div class="upload-btn"
							:style="{ 'background-image': 'url(' + (transferQrImg ? transferQrImg : '../assets/images/header.png') + ')' }">
							<i v-if="!transferQrImg"></i>
						</div>
					</cube-upload-btn>
				</cube-upload>
			</div>
			<div class="wrap-item item_top">
				<span class="item-label">花呗支付码：</span>
				<cube-upload class="header-wrap" ref="uploadFile" :max="1" :auto="false"
					@files-added="creditFilesAdded">
					<cube-upload-btn :multiple="false">
						<div class="upload-btn"
							:style="{ 'background-image': 'url(' + (creditQrImg ? creditQrImg : '../assets/images/header.png') + ')' }">
							<i v-if="!creditQrImg"></i>
						</div>
					</cube-upload-btn>
				</cube-upload>
			</div>
			<div class="tusd-btn first-btn" @click="addAccount">确认添加</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'addAlipay',
	data() {
		return {
			account: {
				BankUser: "",
				BankAccount: "",
				AlipayUid: "",
				qrCodeUrl: "",
				transferQrCodeUrl: "",
				creditQrCodeUrl: "",
				perLimit: 50000,
				dayLimit: 500000,
				groupId: "",
				bankRemark: "",
				perLimitMin: 1000,
				dayLimitOrderCount: 1,
				isShowQrCode: 1,
				isShowBankAccount: 1,
				paymentCustomerLimit: 1,
				isNeedLockedOrder: 1,
				sellTimeSpanLimit: 10
			},
			bankGroupOptions: [],
			params: {},
			statusOptions: ["是", "否"],
			optionCheckedValue: {
				showBankAccountStatus: "是",
				showQrCodeStatus: "是",
				paymentCustomerLimitValue: "正常",
				isNeedLockedOrderValue: "禁止"
			},
			status: [
				{
					label: "是",
					value: 1
				},
				{
					label: "否",
					value: 0
				}
			],
			headerImg: "",
			transferQrImg: "",
			creditQrImg: "",
			status: [
				{
					label: "是",
					value: 1
				},
				{
					label: "否",
					value: 0
				}
			],
			paymentCustomerLimitOptions: ["全部", "正常", "新疆"],
			paymentCustomerLimitProp: [
				{
					label: "全部",
					value: 0
				},
				{
					label: "正常",
					value: 1
				}
				,
				{
					label: "新疆",
					value: 2
				}
			],
			isNeedLockedOrderOptions: ["允许", "禁止"],
			isNeedLockedOrderProp: [
				{
					label: "允许",
					value: 0
				},
				{
					label: "禁止",
					value: 1
				}

			],
		};
	},
	watch: {
		"headerImg"(newVal, oldVal) {
			if (newVal) {
				this.filesSubmit(1)
			}
		}, "transferQrImg"(newVal, oldVal) {
			if (newVal) {
				this.filesSubmit(2)
			}
		}, "creditQrImg"(newVal, oldVal) {
			if (newVal) {
				this.filesSubmit(3)
			}
		}
	},
	methods: {
		goBack() {
			this.$router.push({ name: this.params.back });
		},
		changeShowBankAccount(v) {
			this.account.isShowBankAccount = this.getProp(v, this.status);
		},
		changeShowQrCode(v) {
			this.account.isShowQrCode = this.getProp(v, this.status);
		},
		changePaymentCustomerLimit(v) {
			this.account.paymentCustomerLimit = this.getProp(v, this.paymentCustomerLimitProp);
		},
		changeIsNeedLockedOrder(v) {
			this.account.isNeedLockedOrder = this.getProp(v, this.isNeedLockedOrderProp);
		},
		getProp(v, o, r) {
			let prop = '';
			o.map(i => {
				if (r) {
					if (i.value == v) {
						prop = i.label;
					}
				} else {
					if (i.label == v) {
						prop = i.value;
					}
				}
			});
			return prop;
		},
		selectBankGroup(value, index, text) {
			this.account.groupId = value;
		},
		getUserBankGroupList() {
			let that = this;
			this.$api.getUserBankGroups().then((res) => {
				res.data.filter((item) => item.PayType == 2).map(v => {
					let temp = { text: v.Title, value: v.Id };
					that.bankGroupOptions.push(temp)
				})
			});

		},
		addAccount() {
			let that = this;
			if (!that.account.BankAccount) {
				that.$message.popup("请输入支付宝账号", 1000);
				return false
			}
			// if (!that.account.AlipayUid) {
			// 	that.$message.popup("请输入支付宝UID", 1000);
			// 	return false
			// }
			if (!that.account.BankUser) {
				that.$message.popup("请输入收款方全称", 1000);
				return false
			}
			if (!that.account.dayLimit || that.account.dayLimit < 500) {
				that.$message.popup("请输入单日总限额,最低金额500", 1000);
				return false
			}
			if (!that.account.perLimitMin || that.account.perLimitMin < 500) {
				that.$message.popup("请输入单笔最低限额,最低金额500", 1000);
				return false
			}
			if (!that.account.perLimit || that.account.perLimit < 500) {
				that.$message.popup("请输入单笔最高限额,最低金额500", 1000);
				return false
			}
			if (!that.account.dayLimitOrderCount || that.account.dayLimitOrderCount < 1) {
				that.$message.popup("请输入单日限单量,最少一单", 1000);
				return false
			}
			if (parseInt(that.account.perLimit) < parseInt(that.account.perLimitMin)) {
				that.$message.popup("单笔最高不得低于单笔最低", 1000);
				return false
			}
			if (!that.account.groupId) {
				that.$message.popup("请选择分组管理", 1000);
				return false
			}
			if (!that.account.bankRemark) {
				that.$message.popup("请输入收款方编号", 1000);
				return false
			}
			if (that.account.isShowBankAccount == 0 && that.account.isShowQrCode == 0) {
				that.$message.popup("展示账号与展示二维码至少一个选择 “是” ", 1000);
				return false
			}
			if (that.account.isShowQrCode == 1 && !that.account.qrCodeUrl && !that.account.transferQRCodeUrl && !that.account.creditQRCodeUrl) {
				that.$message.popup("展示二维码的情况下，请至少上传一个收款码", 1000);
				return false
			}

			if (parseInt(that.account.sellTimeSpanLimit) <= 0 || parseInt(that.account.sellTimeSpanLimit) > 1440) {
				that.$message.popup("匹配间隔只能设置0至一天（1440分钟）之间", 1000);
				return false
			} else {
				that.account.sellTimeSpanLimit = 0;
			}
			that.$api.addAlipay(that.account).then((res) => {
				that.$message.popup(res.msg, 1000);
				setTimeout(() => {
					that.goBack();
				}, 1000);
			})
		},
		filesAdded(files) {
			let hasIgnore = false;
			const limitSize = 2 * 1024 * 1024;
			// 最大5M
			const maxSize = 5 * 1024 * 1024;
			for (let i = 0; i < files.length; i++) {
				const file = files[i];
				// 如果选择的图片大小最大限制（这里为5M）则弹出提示
				if (file.size > maxSize) {
					file.ignore = true;
					hasIgnore = true;
					break;
				}
				// 如果选择的图片大小大于1M则进行图片压缩处理（Base64）
				if (file.size > limitSize) {
					this.compressPic(file);
				} else {
					let reads = new FileReader();
					reads.readAsDataURL(file);
					let that = this;
					reads.onload = function (e) {
						var bdata = this.result;
						file.base64 = bdata;
						that.headerImg = bdata
						that.hasChange = true;
					};
				}
			}
			hasIgnore && this.$message.popup("图片最大支持5M", 1000);
		},
		transferFilesAdded(files) {
			let hasIgnore = false;
			const limitSize = 2 * 1024 * 1024;
			// 最大5M
			const maxSize = 5 * 1024 * 1024;
			for (let i = 0; i < files.length; i++) {
				const file = files[i];
				// 如果选择的图片大小最大限制（这里为5M）则弹出提示
				if (file.size > maxSize) {
					file.ignore = true;
					hasIgnore = true;
					break;
				}
				// 如果选择的图片大小大于1M则进行图片压缩处理（Base64）
				if (file.size > limitSize) {
					this.compressPic(file);
				} else {
					let reads = new FileReader();
					reads.readAsDataURL(file);
					let that = this;
					reads.onload = function (e) {
						var bdata = this.result;
						file.base64 = bdata;
						that.transferQrImg = bdata;
						that.hasChange = true;
					};
				}
			}
			hasIgnore && this.$message.popup("图片最大支持5M", 1000);
		},
		creditFilesAdded(files) {
			let hasIgnore = false;
			const limitSize = 2 * 1024 * 1024;
			// 最大5M
			const maxSize = 5 * 1024 * 1024;
			for (let i = 0; i < files.length; i++) {
				const file = files[i];
				// 如果选择的图片大小最大限制（这里为5M）则弹出提示
				if (file.size > maxSize) {
					file.ignore = true;
					hasIgnore = true;
					break;
				}
				// 如果选择的图片大小大于1M则进行图片压缩处理（Base64）
				if (file.size > limitSize) {
					this.compressPic(file);
				} else {
					let reads = new FileReader();
					reads.readAsDataURL(file);
					let that = this;
					reads.onload = function (e) {
						var bdata = this.result;
						file.base64 = bdata;
						that.creditQrImg = bdata;
						that.hasChange = true;
					};
				}
			}
			hasIgnore && this.$message.popup("图片最大支持5M", 1000);
		},
		filesSubmit(type) {
			if (this.headerImg || this.transferQrImg || this.creditQrImg) {
				var data;
				if (type == 1) {
					data = {
						file: this.headerImg,
					}
				} else if (type == 2) {
					data = {
						file: this.transferQrImg,
					}
				} else {
					data = {
						file: this.creditQrImg,
					}
				}
				this.$api.alipayImgUpload(data).then((res) => {
					this.$message.popup("上传成功", 1000);
					if (type == 1) {
						this.account.qrCodeUrl = res.data
					} else if (type == 2) {
						this.account.transferQrCodeUrl = res.data
					} else {
						this.account.creditQrCodeUrl = res.data
					}
				})
			}
		},
		// 图片压缩方法
		compressPic(file) {
			let reads = new FileReader();
			reads.readAsDataURL(file);
			// 注意这里this作用域的问题
			let that = this;
			reads.onload = function (e) {
				var bdata = this.result;
				// 这里quality的范围是（0-1）
				var quality = 0.1;
				var canvas = document.createElement("canvas");
				var ctx = canvas.getContext("2d");
				var img = new Image();
				img.src = bdata;
				img.onload = function () {
					var width = img.width;
					canvas.width = width;
					canvas.height = width * (img.height / img.width);
					ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
					let data = canvas.toDataURL("image/jpeg", quality);
					file.base64 = data
					that.headerImg = bdata
					that.hasChange = true;
				};
			};
		},
	},
	created() {
		this.params = this.$store.state.routerStore.addAlipay;
		if (!this.params.back) {
			this.params.back = 'accounts';
		}
		this.getUserBankGroupList();
	}
};
</script>
<style lang="less" scoped>
.header-wrap {
	display: inline-block;
	width: 80px;
	height: 80px;
	margin: 15px 0;

	.upload-btn {
		width: 100%;
		height: 100%;
		background: url(../assets/images/header.png) center center no-repeat;
		background-size: contain;
		border: 2px solid #cdcdcd;

		i {
			display: inline-block;
			vertical-align: middle;
			width: 75px;
			height: 80px;
			margin-right: 8px;
			background: url(../assets/images/upload.svg) center center no-repeat;
		}

	}

	.cube-upload-btn {
		height: 100%;
	}

}

.item_top {
	display: flex;
	flex-direction: row;
	align-items: flex-start;
}
</style>
